<template>
  <div class="isis-page__header md-layout">
    <div class="md-layout-item md-size-100">
      <div class="nav-link" @click="goToPreviousPage()">
        <i class="fas fa-chevron-left"></i>
        <span>{{ $t("task_management.add_main_task") }}</span>
      </div>
    </div>
    <MainPage mode="add" @manageTask="addTask"></MainPage>
  </div>
</template>
<script>
import { hasHistory, Message } from "@/helpers/utils";
import MainPage from "../Component/MainPage";
import { service_names } from "@/constants/Services";

export default {
  components: {
    MainPage
  },
  data() {
    return {};
  },

  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    addTask(data) {
      this.$axios
        .post(`${service_names.school}/main-task`, data)
        .then(response => {
          Message.success(this.$t("task_management.add_successfully"));
          this.$router.push({ path: `/edit-main-task/${response.data.id}` });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.header-title {
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: 0.18px;
  color: #1b1f22;
  cursor: pointer;
}
</style>
